<template>
  <pre>
      <template v-if="lang==$config.LANG_KOR">
        <h1>KB 글로벌인터넷뱅킹 이용약관 </h1>
  
제 1 조 (목적) 
①	이 약관은 KB국민은행 오클랜드 지점(이하 “은행”이라 한다)과 KB 글로벌 인터넷뱅킹서비스(모바일뱅킹서비스 포함, 이하 “서비스”라 한다)를 이용하는 고객(이하 “이용자”라 한다) 사이의 서비스 이용에 관한 제반 사항을 정함을 목적으로 한다. 본 서비스를 이용함으로써 사용자는 본 약관에 합의하여 본 약관을 따를 것에 동의함을 의미한다.
②	본 서비스를 이용함에 있어 개별 계정 약관, 은행의 표준 약관 및 개인 정보 보호 규정과 같은 다른 약관 또한 적용된다. 요청이 있을 시, 은행은 이용자에게 본 약관 문서 사본을 제공한다.
제 2 조 (약관의 적용)
①	은행과 이용자 사이에 별도로 합의한 사항이 이 약관에 정한 사항과 다를 때에는 그 합의사항을 이 약관에 우선하여 적용한다. 
②	본 약관은 이용자의 편의를 위하여 영문본과 국문본으로 제공된다. 본 이용약관의 영문본과 국문본이 상충하는 경우, 관련 법률에서 허용되는 한 영문본이 국문본에 우선한다.
③	본 서비스를 이용하는 이용자는 전자적 수단에 의한 개인정보제공에 동의한다.

제 3 조 (이용자)
본 서비스는 개인고객, 법인 고객 및 개인사업자를 대상으로 한다.

제 4 조 (용어의 정의)
①	이 약관에서 사용하는 용어의 정의는 다음 각호와 같다.
1.	“자동이체”란 이용자의 거래 요청서에 명시된 기간마다 인출 계정에서 지정 수신 계정으로 반복하여 지급되도록 설정된 특정 금액의 이체를 말한다.
2.	“은행”이란 국민은행 오클랜드 지점을 이른다. 
3.	“바이오 인증”이란, 지문, 안면, 음성 인식 및 기타 “이용자”가 허용한 서비스 접근 방식 내에서 전자 장치 제조사가 제공하는 생체 인증 방법 등을 이용하여 서비스에 접근하는 방식을 의미한다.
4.	“영업일”이라 함은 통상 은행이 영업점에서 정상적인 영업을 하는 날을 의미하며 토요일과 일요일은 포함하지 않는다.
5.	”EASY-PIN””란 전자금융서비스 이용 시 이용자의 본인확인수단으로서 이용자가 직접 지정한 6자리의 숫자가 조합된 개인인증번호 (PIN) 를 말한다.
6.	“전자 장치” 란 컴퓨터와 같이 서비스에 접속하여 이용하기 위해 사용되는 전자 장비를 의미한다.
7.	“오류”라 함은 이용자의 고의, 약관의 위반, 과실 없이 서비스의 약관 또는 이용자가 거래 지시한 대로 이행되지 아니한 경우를 말한다. 오류가 분명한 경우를 제외하고, 서비스와 거래에 관한 은행의 기록은 그러한 거래의 입증 근거가 된다.
8.	“최종승인권자”란 은행이 지시에 대한 최종 승인 권한을 부여할 권한이 있는 자로 지정한 이용자 또는 이용자 클래스에 의해 부여된 최종 승인을 의미한다. 일부 거래는 최종승인권자가 제공된 경우에만 처리된다.
9.	“Master(마스터)”는 서비스를 사용할 완전한 액세스 권한과 권한을 가진 이용자 또는 이용자 클래스를 의미한다. 마스터는 서비스 이용을 위한 Sub의 액세스 수준 및 권한을 설정하는 것을 말한다.
10.	“접근매체”라 함은 서비스에 액세스하거나 서비스를 통해 거래를 요청하는 데 사용되는 수단 또는 정보를 말하며 다음 중 일부 또는 전부를 포함한다.
(1)	은행이 수시로 제공하는 전자카드 및 정보
(2)	은행에 등록된 이용자의 정보, 계좌번호, 계좌비밀번호, 사용자 암호
(3)	(1)을 사용하기 위해 필요한 비밀번호, 그리고
(4)	바이오 인증
11.	“OTP”(일회용 비밀번호)는 서비스에 대한 단일 거래 및/또는 로그인 응답에 대해 사용자를 인증하기 위해 무작위로 자동 생성되는 일회용 비밀번호를 말한다.
12.	“지급인”이라 함은 서비스에 의하여 자금이 출금되는 계좌(이하 “출금계좌”라 한다)의 명의인을 말한다
13.	“수취인”이라 함은 서비스에 의하여 자금이 입금되는 계좌(이하 “입금계좌”라 한다)의 명의인을 말한다
14.	“예약에 의한 계좌이체”라 함은 계좌이체가 장래의 특정 일자에 이루어지도록 이용자가 미리 거래지시하고 은행이 이를 해당 일자에 처리하는 것을 말한다
15.	“서비스”라 함은 은행이 전자 기기용으로 만들어진 소프트웨어 응용 프로그램, 웹 응용 프로그램 또는 기타 수단을 통해 인터넷 상에서 이용자들에게 제공하는 제5조에 명시된 은행 서비스의 종류를 말한다.
16.	“Sub”란 마스터가 설정한 접근 권한 및 권한 수준에 따라 서비스에 접근하고 이를 사용할 수 있는 이용자를 말한다.
17.	“거래지시”라 함은 이용자가 은행의 전자적 장치에서 서비스를 처리할 것을 은행에 요구하는 것을 말한다.
18.	“계좌이체”라 함은 지급인의 지급 지시에 따라 은행이 지급인의 출금계좌에서 자금을 출금하여 같은 은행 또는 다른 은행의 계좌에 입금하는 것을 말한다.
19.	“이용자ID”라 함은 이용자가 은행에 등록한 6~12자리의 영문 또는 영문과 숫자의 조합을 말하며 이용자가 서비스에 접속할 때 사용한다.
20.	“사용자 암호”라 함은 서비스에 접속하기 위하여 이용자가 선택하여 사용할 수 있는 6~12자리의 영문과 숫자의 조합을 말한다.
21.	“이용자”는 서비스에 가입하거나 은행의 계좌, 상품 또는 서비스에 대한 액세스를 제공 받는 사람을 말한다.

제 5 조 (서비스 종류) 
은행이 제공하는 서비스 종류는 각종 계좌 조회, 이체 서비스, 계좌개설해지, 대출 신청, 해외송금, 자동이체 등록 등이며 자세한 사항은 해당 서비스를 통해 안내한다.

제 6 조 (서비스 신청 및 해지)
①	서비스의 제공은 이용자가 은행에 서비스 신청서 (이하 “신청서”라 한다)를 서면으로 제출하고 은행이 이를 접수하여 승낙함으로써 개시된다. 
②	서비스 해지는 이용자가 서면으로 작성하여 요청한다. 다만, 특정 서비스는 이용자가 전자기기를 사용하여 서비스의 특정 기능을 사용함으로써 직접 해지를 하여야 할 수도 있다. 이러한 경우, 이용자가 해지에 대한 모든 책임을 진다.
③	은행은 합당한 사유가 있다고 판단되는 경우(예를 들면, 위법한 경우) 이용자의 손실에 대한 책임 없이 언제든지 이용자의 서비스 접근 또는 기능을 정지하거나 해지할 수 있다.



제 7 조 (이용자의 본인확인 방법)
①	이용자는 동 약관의 제4조 제7호에 규정된 접근매체 중 일부 또는 전부를 은행이 안내한 전자기기를 사용하여 접근 권한을 부여받고 서비스를 이용할 수 있다
②	이용자는 은행이 이용자가 접근매체를 사용하여 등록된 모든 지시사항(거래)을 실행 하는 것에 동의한다. 이용자는 은행이 거래를 진행하는 것과 지시사항에 대해 은행에 거래 권한을 부여한 것과 상관없이 실행할 수 있는 권한을 부여했다는 것을 인지한다.
③	은행은 지시사항에 관해서 이용자에게 요청하거나 확인할 권리를 가지지만 요구 사항은 아니며, 지시사항의 확인을 위해 접근매체의 사용, 이용자의 추가적인 신원확인 또는 추가 정보 요구 등 추가 절차를 진행할 수 있다.
④	이용자가 바이오 인증을 통하여 서비스 이용 시 사용자 암호 또는 EASY-PIN를 제공할 필요가 없다. 다만, 해당 거래 및 이용 제한에 대해서는 이용자가 쉽게 접근할 수 있는 전자기기를 통하여 공지된다.

제 8 조 (접근매체의 발급 및 등록)
①	은행이 최초의 접근매체를 이용자의 신청이 있는 경우에 한하여 본인임을 확인한 후에 발급한다
②	이용자는 은행에서 등록한 최초의 접근매체를 통하여 본 서비스에 접속한다. 이용자는 첫 접속 시 사용자 암호를 설정해야 한다
③	기업고객(개인사업자 포함)의 경우 영업점에서 Master는 서비스의 초기 접근매체의 수단으로 OTP를 은행에서 받는다. Master는 서비스를 처음 접근할 때 사용자 암호를 설정하여야 한다. Master는 고객 ID를 제공하고 각 Sub에 대한 접근 및 권한 수준을 설정하여 sub를 등록할 수 있다. 등록할 때 각 Sub는 초기 접근 수단으로 OTP를 제공받는다. 각 Sub는 서비스에 처음 접근할 때 사용자 암호를 설정해야 한다
④	Master는 sub의 서비스 이용에 관련하여 sub의 모든 행위 및 누락에 대한 책임이 있다. 은행은 서비스와 관련하여 각 Sub를 Master의 대리인으로 간주한다. 은행은 이 서비스들과 관련하여 sub의 행위 또는 누락으로 인해 발생하는 손실 또는 손해에 대해 책임을 지지 않는다

제 9 조 (접근매체 관리)
①	이용자는 제3자에게 접근매체를 대여, 위임, 양도하거나 담보로 제공해서는 안 된다
②	이용자는 제3자에게 접근매체를 유출해서는 안 되며, 접근매체의 절도(분실, 도난), 위조 또는 변조를 방지하기 위해 각별히 주의해야 한다
③	이용자는 반드시 적절한 사용자 암호 및 EASY-PIN을 사용해야 한다. 연속되는 숫자 또는 개인 정보의 문자/숫자 (예: 이용자의 생년월일, 전화번호, 개인식별번호 등)는 비밀번호로 사용할 수 없다. 은행은 이용자의 부적절한 비밀번호 사용으로 인한 손해에 대해 책임지지 않는다
④	이용자는 사용자 암호 및 EASY-PIN를 암기해야 하며, 서면으로 적어두어서는 안 된다
⑤	이용자는 전자기기에 비밀번호를 저장해서는 안 된다
⑥	이용자는 접근매체의 유출, 분실 또는 도난을 인지했거나 의심되는 경우, 즉시 은행에 신고해야 한다

제 10 조 (출금계좌)
①	이용자는 계좌 신청서에 은행이 자금 이체에 사용할 최초 출금계좌를 지정해야 한다. 또한 이용자는 은행이 정하는 관련 서비스 지침에 따라 추가적인 출금계좌를 지정할 수 있다.
②	출금계좌로 신청할 수 있는 예금은 본인 명의 또는 공동명의의 요구불예금에 한한다 이용자는 본인 명의 또는 공동 명의의 계좌만 출금계좌로 지정할 수 있다

제 11 조 (입금계좌)
은행은 이용자가 제공한 정보에 따라 거래를 진행한다. 이용자가 부정확한 계좌 정보를 제공하여 발생하는 이체 지연, 반환, 수취 거절 및 이로 인한 손해는 이용자의 책임으로 한다

제 12 조 (1회 이체한도 및 1일 이체한도)
①	이용자는 “1회 이체한도”와 “1일 일체한도”를 서비스 신청서에 반드시 작성해야 한다
②	이용자는 은행에 서면으로 통지함으로써 1회 이체한도와 1일 이체한도를 변경 할 수 있다. 특정 서비스의 경우, 은행이 지정한 해당 서비스의 기능을 통해 통지 할 수 있다
③	Sub의 1회 이체한도와 1일 이체한도는 Master의 1회 이체한도와 1일 이체한도와 같거나 적어야 한다
④	자동이체, 대출이자납입, 은행수수료납부 등 일부 거래에 대해서는 이체한도가 적용되지 않는다

제 13 조 (거래지시의 처리)
①	은행은 이용자의 거래지시에 포함된 접근매체 및 OTP가 은행에 등록된것과 일치하는 경우에 거래지시에 따라 처리한다.
②	은행은 필요하다고 판단되는 경우 은행의 재량에 따라 이용자에게 별도의 안내 없이 거래지시를 거절, 유예, 차단 할 수 있다. (예: 이용자의 요청에 따르는 것이 위법일 경우)
③	거래지시가 최종승인권자의 전자결재가 필요하다고 판단되는 경우, 은행은 최종승인권자의 전자결재가 이루어 지기 전까지 거래를 진행하지 않는다
④	거래에 대한 최종승인권자의 전자결재가 규정된 시간 안에 제공되지 않을 경우, 거래는 자동으로 취소된다
⑤	이용자는 출금계좌의 출금 가능 잔액이 요청된 거래금액과 적용되는 수수료의 합계 금액을 초과하도록 해야 한다. 어떠한 사유로든 거래가 처리되지 않는 경우, 이용자는 후속 처리를 해야 한다 
⑥	출금계좌의 출금 가능 잔액이 거래 금액과 수수료의 합계 금액보다 부족한 경우, 은행은 출금거래를 거절하거나 당좌약정 적용하여 인출 거래를 진행 할 수 있다
⑦	은행은 이용자의 거래 지시에 별도의 지급 요청서나 추가 확인 없이 출금계좌에서 자금을 인출할 수 있다

제 14 조  (거래 지시의 철회)
①	이용자는 은행이 제공한 해당 서비스 이용 매체를 통해 은행에 통보함으로서 거래 지시를 철회 할 수 있다. 은행은 거래 지시 철회 가능 여부를 알려 주도록 한다.  
②	이용자는 은행이 처리 통보를 받은 날부터 그러한 지시 처리에 최대 1 영업일이 소요되며, (거래 요청을 포함하여) 그러한 거래 지시를 중지 시킬 수 없거나 기 처리 된 경우에는 은행이 그로 인해 발생하는 손실에 대한 책임이 없음을 인정하고 동의한다.
③	이용자의 실수에 의한 계좌 이체는 반드시 입금 계좌 예금주의 동의를 얻어야만 취소처리가 가능함을 이용자는 동의한다.
④	출금 계좌를 해지할 때에는 해당 계좌에 등록된 예약 계좌이체 거래 지시도 철회된다.
⑤	이용자의 사망· 한정치산선고· 금치산선고나 이용자 또는 은행의 해산· 합병· 파산은 (해당 시) 그 자체로는 거래 지시에 영향을 미치거나, 철회 또는 변경하는 것으로 되지 아니하며 은행의 권한에도 영향을 미치지 아니한다.



제 15 조 (오류의 정정) 
이용자는 전자금융거래에 오류가 있음을 안 때에는 은행에 정정을 요구할 수 있으며 이 경우 은행은 이를 조사하여 필요한 조치를 처리한 후 그 조치에 대해 이용자에게 알려야 한다.

제 16 조 (이용자 정보의 변경 및 사고, 분실 신고)
①	이용자가 사용자 암호, 출금 계좌, 성명, 상호, 주소, 전화번호 등 은행에 등록한 사항을 변경하고자 하는 때에는 소정의 신청서를 영업점에 제출하여야 한다. 그러한 변경사항은 은행이 알려준 서비스 내의 이용 매체를 통해 통보 가능하다. 
②	이용자는 거래 계좌에 관한 접근 수단의 도난, 분실, 위조 또는 변조의 사실을 인지하거나 기타 거래 절차상 비밀을 요하는 사항이 누설되었음을 인지할 때에는 지체 없이 이를 은행에 신고한다.
③	제2항에 의해 은행은 이를 접수한 즉시 모든 서비스 이용을 중단한다. 
④	상기 제2항에 의한 통보를 철회할 경우에는 은행은 은행재량에 따라 신고 철회를 수락 할 수 있다. 서비스 이용자는 서비스 재개를 위한 서면 신청서를 제출해야 한다.

제 17 조 (서비스 이용의 제한) 
①	이용자는 합법적 용도가 아닌 다른 목적으로 서비스를 이용하지 않음에 동의한다.
②	다음 각 호의 경우에 은행은 해당 이용자에 대한 서비스의 전부 또는 일부를 제한할 수 있다.
1.	사용자 암호가 3회 연속하여 잘못 입력된 경우 단, EASY-PIN의 경우 5회 이상 연속하여 잘못 입력한 경우
2.	바이오 인증의 경우 이용자가 5회 이상 실패한 경우
3.	계좌비밀번호가 4회 연속하여 잘못 입력된 경우
4.	OTP에서 생성되는 비밀번호를 10회 이상 연속하여 틀린 경우
5.	이용자가 설정한 이체 한도를 초과하여 계좌이체 거래 지시를 한 경우
6.	거래의 처리 시점에 출금 계좌의 잔액이 거래금액과 이용수수료를 합한 금액보다 적은 경우
7.	22조 2항에 의거한 통지방식으로 고객에게 은행이 통지한 경우
8.	입금 또는 출금 계좌가 해지 되었거나 거래 중지 계좌에 편입되었을 때
9.	법적 지급제한 등으로 거래 제공이 부적합하다고 은행이 인정한 경우
10.	기기 장애, 네트워크 문제 및 파업 행위를 포함해 은행이 통제할 수 없는 시스템 오류 상황으로 인해 서비스 이용이 불가한 경우
③	은행이 가능한 경우, 서비스 사용제한에 대해 이용자에게 22조 2항에 따라 통지하도록 하며 이용자는 은행이 일부 경우 통지가 불가한 상황 (예 시스템 오류로 서비스 자체 사용이 불가능할 경우)이 발생할 수 있음을 인지하고 동의한다.
④	어떠한 이유로 서비스 오작동 및 이용이 불가한 경우, 여타 수단을 사용하여 은행 거래를 실행하는 것은 이용자의 책임이다. 법이 허용하는 범위 내에서, 은행은 은행의 서비스 또는 서비스의 기능 제한으로 발생하는 어떠한 손실에 대해서도 책임지지 아니한다.





제 18 조 (이용시간)
①	상기 17조를 조건으로 하여, 이용자는 은행 웹사이트에 게시된 은행이 정한 이용시간 동안 서비스를 이용할 수 있다. 
②	이용시간은 은행의 사정에 따라 달라질 수 있으며, 이용시간을 변경하고자 할 경우에는 22조 2항에 따라 통지한다. 다만, 시스템 장애 복구, 긴급한 프로그램 보수, 외부요인 등 불가피한 경우에는 예외로 한다.

제 19 조 (서비스 수수료)
①	본 약관 [별지서식1]에 명시된 수수료가 부가된다. 서비스 제공과 동시에 은행이 출금계좌에서 자동으로 돈을 출금하며, 은행은 22조 2항의 통지에 따라 서비스 수수료를 변경할 수 있다. 
②	서비스 접속 시 인터넷 서비스 사업자 및 이동통신 사업자에 의해 청구되는 모든 수수료에 대한 책임은 이용자에게 있다. 

제 20 조 (면책) 
①	법에 따라 허용되는 범위 내에서, 은행은 다음 각 호의 상황을 포함하여 (제한 없이) 어떠한 손실, 피해, 청구, 또는 서비스와 관련하여 직/간접적으로 발생하는 사안에 대한 책임을 지지 않는다.     
1.	이용자의 접근 매체의 오용으로 인한 보안 위반과 연관 된 경우 
2.	이용자의 계정 운영 권한 또는 대리 권한에 의해 거래 지시를 처리한 경우
3.	합리적 수준에서 거래 지시서를 통해 감지 할 수 없는 승인되지않거나 위조된 또는 조작된 거래 지시를 처리한 경우
4.	불명확하거나 모순된 것으로 보이는 거래를 처리 하지 않은 경우
5.	이용자가 거래 지시에 대한 해당 약관을 준수 하지 않은 경우
6.	장비 및 시스템 오작동 또는 통신 연결이 불가 할 때
7.	은행이 통제할 수 없는 원인 또는 사건이 발생한 경우
8.	천재지변, 전쟁, 정전, 화재 또는 테러 등 불가항력으로 인한 예측 불가한 사고가 발생한 경우

②	이용자의 책임은 다음과 같다. 
1.	서비스 호환이 되는 전자 장치를 이용, 보유 및 확보한다. 이용자의 전자 장치 사용 또는 그 전자 장치를 통해 접속한 서비스와 관련된 이용 약관의 준수 및 수수료는 이용자의 책임이다.
2.	서비스 이용을 위해 전자 장치를 사용하기 전에, 전자장치 내 악성 코드 (트로이), 키로깅 (Key logging), 바이러스, 스파이웨어 및 기타 이용자가 알고 있는 악성 소프트웨어를 해결한다.
③	부정 및 과실 행위로 인한 직접적인 손실이 아니라면, 이용자의 거래지시를 실행함으로서 발생한 모든 손해, 행위, 비용 및 손실에 대해 은행은 책임지지 아니한다. 

제 21 조 (이용자 정보)
①	은행의 개인정보처리규정은 본 서비스에 적용된다. 본 서비스를 이용함으로써 이용자는 개인정보처리 규정에 따라 (개인정보를 포함한) 정보의 수집, 이용, 공개에 동의한 것으로 본다. 개인정보 처리 규정은 인터넷뱅킹 웹사이트 (Home > 개인정보보호정책)에 안내 되어 있다.
②	은행은 개인 정보가 아닌 정보를 수집, 이용, 공개할 경우가 있으며, 그때 은행의 개인정보처리규정은 (비 개인 정보)에 적용 되지 않는다. 은행이 사업자 고객에 대한 정보를 수집하는 경우가 이에 포함된다. 이용자는 은행의 시스템을 관리하고 개선하며, 상품/마케팅 목적을 위해 비개인 정보를 수집, 이용, 공개할 권한을 은행에 부여한다. 은행은 금융 및 보안 리스크를 관리하고, 시스템을 모니터하고, 권리를 옹호하거나 행사하고, 법적 의무를 이행할 수 있도록 비개인 정보를 사용할 수 있다.   
③	이용자는 은행에 대한 비개인 정보의 제공에 동의하며, 은행은 뉴질랜드 및 해외 현지 법을 준수하기 위해 비 개인 정보를 (제 3자로부터의 정보 포함) 수집, 이용 공개할 수 있다. 은행은 이용자의 계정을 모니터하고, 뉴질랜드 및 해외 현지의 법과 관련하여 위장 거래 및 범죄의 감지 및 자금세탁 및 테러 자금 방지, 서비스 악용 및 서비스 무단 이용을 예방하기 위해 비 개인 정보를 제공할 수 있다.

제 22 조 (약관 변경)
①	법이 허용한 범위에서, 은행은 [별지서식1] 에 명시한 서비스, 약관, 수수료를 변경할 수 있다. 만약 이용자에게 영향을 미치는 방법으로 약관을 수정하는 경우, 22조 2항에 의해 그러한 변경 안을 이행일 1개월 전까지 이용자에게 통보한다. 그러나 은행의 시스템 보안 및 법 개정안의 준수를 위한 변경의 경우, 약관 변경 이후에 이용자에게 고지할 수 있다.
②	은행은 각 호의 어느 하나에 해당하는 방법으로 이용자에게 통보할 수 있다. 
1.	은행의 실제 지점에 공고문 게시 
2.	은행의 웹사이트에 게시 
3.	전자기기 기반 서비스 접근 시 볼수 있는 방식으로 공고문 게시 
4.	이메일을 통한 이용자 통지 
③	만약 이용자가 변경사항에 동의하지 않을 경우, 이용자는 약관 6조에 따라 언제든지 서비스를 해지할 수 있다. 만약 이용자가 약관 변경 발효일 영업일 하루 전 영업일까지 해지하지 않을 경우, 이용자는 해당 변경(들)에 대해 동의한 것으로 간주된다.  

제23조 적용 가능한 기타 일반 조건
①	이용자가 사업상의 목적으로 서비스를 사용하는 경우 (또는 사용자가 그렇게 한다고 주장하는 경우) 이용자는 서비스 또는 관련 상품에 Consumer Guarantees Act 1993이 적용되지 않는 것에 동의합니다
②	뉴질랜드 법원이 본 이용 약관의 조항이 위법하다 판단하는 경우 은행은 해당 조항을 삭제하며 그외 조항은 지속됩니다.
③	은행은 그 권리를 행사할 수 있는 권리를 보유합니다. 은행이 본 약관에 따른 권리를 즉시 행사하지 않더라도 향후에도 여전히 그 권리를 행사할 수 있습니다.
④	이러한 조건에는 뉴질랜드 법이 적용됩니다.



부  칙(1)

제 1 조(시행일) 이 약관은 2013. 3. 11 부터 시행한다.

부  칙(2)

제 1 조(시행일) 이 약관은 2016. 11. 28 부터 시행한다.

부  칙(3)

제 1 조(시행일) 이 약관은 2021. 11. 22 부터 시행한다

 
[별지서식1]
서비스 이용 수수료

<table class="table -type04 nomargin">
  <colgroup>
    <col width="26%" />
    <col width="26%" />
    <col />
    <col width="18%" />
    <col width="18%" />
  </colgroup>
  <thead>
    <tr>
      <th scope="col">Service</th>
      <th scope="col">Detail</th>
      <th scope="col">Per</th>
      <th scope="col">Currency</th>
      <th scope="col">Charges</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>당행이체</td>
      <td>당행계좌간 이체</td>
      <td>건</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td>타행이체신청</td>
      <td>타행계좌로 이체신청</td>
      <td>건</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td rowspan="2">외화이체</td>
      <td>당행 외화계좌로 이체 </td>
      <td>건</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td>타행 외화계좌로 이체 </td>
      <td>건</td>
      <td>NZD</td>
      <td>25.00 </td>
    </tr>
      <tr>
      <td rowspan="2">자동이체수수료</td>
      <td>설정 </td>
      <td>건</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td>지급</td>
      <td>지급시</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td>해외송금</td>
      <td>외화 당발 송금수수료</td>
      <td>건</td>
      <td>NZD</td>
      <td>25.00 </td>
    </tr>
    <tr>
      <td>OTP</td>
      <td>발급 수수료</td>
      <td>건</td>
      <td>NZD</td>
      <td>15.00 </td>
    </tr>
  </tbody>
</table>
※ 현지은행 사정에 따라 수수료는 변경될 수 있으니 참고하시기 바랍니다.
<br><br><br>
      </template> 
  <template v-if="lang==$config.LANG_ENG">
    <h1>Terms and Conditions for KB Global Internet Banking Service (“Terms and Conditions”)</h1>

Article 1 (Purpose)
①	The purpose of these Terms and Conditions for KB Global Internet Banking Service (including the mobile banking services, hereinafter referred to as the “Services”) is to prescribe general matters with respect to the use of internet banking service provided by Kookmin Bank Auckland Branch (the “Bank”) and the customer (the “User”). By using these Services, the User agrees to these Terms and Conditions and to be bound by them.
②	Other terms and conditions will also apply, such as specific account terms and conditions, the Bank’s Standard Terms and Conditions and its Privacy Policy. The Bank will provide the User copies of these documents on request.
Article 2 (Application of these Terms and Conditions)
①	If a term in any agreement separately executed by the Bank and the User for the provision of separate services conflicts with these Terms and Conditions, those terms shall prevail over these Terms and Conditions. 
②	The Bank will provide the User with a Korean translation of these Terms and Conditions. This translation is provided for the User’s convenience only. In the event of any conflict between the English language version and the translation version of these Terms and Conditions and to the extent permissible by applicable law, the English language version shall prevail over any translation version.
③	The User consents to the Bank providing notices and information by electronic means.
Article 3 (User)
The Services are for personal and business Users.

Article 4 (Terms)
①	The terms used in these Terms and Conditions shall be defined as follows:
1.	“Automatic Transfer” shall mean a payment of a specified amount to go from the Withdrawal Account to a nominated Deposit Account which is set to occur repeatedly at a frequency specified in the User’s Transaction Request.
2.	“Bank” shall refer to Kookmin Bank, Auckland Branch.
3.	“Biometric Authentication” shall mean the mode of accessing the Services using a person's biological traits such as fingerprint identification, facial recognition, voice recognition or other biometric authentication methods that Electronic Device manufacturers may provide from time to time, and to the extent the Bank allows the User to use those methods as a Means of Access to the Services.
4.	“Business Day” shall mean the days on which the Bank is open for normal business operation but does not include Saturday or Sunday.
5.	“EASY-PIN” shall mean a Personal Identification Number that is a combination of six digits chosen by the User as a means of verifying their identity when using the Services on an Electronic Device.
6.	“Electronic Device” shall mean an electronic device used for accessing and using the Services such as a computer.
7.	“Error” shall mean that the Services which were not completed in accordance the User’s request for any reason excluding the User’s fault, breach of these Terms and Conditions, negligence or misconduct. Other than where there is an obvious Error, the Bank’s records of the Services and transactions will be evidence of those transactions.
8.	“FAA” shall mean the final approval given by a User, or class of Users, the Bank designates as the persons authorised to provide the final approval authority for an instruction. Some transactions are only processed when FAA has been given.  
9.	“Master” shall mean a User or a class of Users who has full access and authority to use the Services. The Master sets the Subs’ levels of access and permissions to use the Services.
10.	“Means of Access” shall refer to the means or information which are used to access the Services and/or make a Transaction Request through the Services and includes any or all of the following:
(1)	Electronic cards and information which the Bank provides from time to time;
(2)	the User’s information, account number, PIN numbers and passwords which are registered with the Bank; 
(3)	Passwords that are needed to use (1); and
(4)	Biometric Authentication.
11.	“OTP” (One Time Password) shall mean a single-use password automatically generated at random to authenticate the User for a single transaction and/or login session for the Services.
12.	“Payer” shall mean the holder of the account from which funds are withdrawn (hereinafter, “Withdrawal Account”) in respect of these Services. 
13.	“Recipient” shall mean the holder of the account into which funds are deposited (hereinafter, “Deposit Account”) through these Services.
14.	“Reserved Transfer” shall mean the transactions whereby the User makes a Transaction Request in advance designating a future date as the date on which Transfer Services are to take place, and the Bank executes the requested Transfer Services on such date.
15.	“Service” shall mean the types of banking services stated in Article 5 that the Bank provides to the User on the Internet by means of a software application, web application or any other means that has been created for Electronic Devices. 
16.	“Sub” shall mean a User who has access and may use the Services in accordance with the access and permission levels set by the Master.
17.	“Transaction Request” shall mean the request by which the User asks the Bank to process a Service on its Electronic Device.
18.	“Transfer Services” shall mean the transactions whereby the Bank withdraws funds from a specified account and transfers them to another account opened at the same bank or another bank pursuant to a Transaction Request.
19.	“User ID” shall mean 6~12 English letters or a combination of English letters and numbers that the User registers with the Bank and is used when the User accesses the Services.
20.	“User Password” shall mean a 6~12 character combination of English letters and numbers that the User chooses and may be used to access the Services.
21.	“User” shall mean each person who has signed up for the Services or a person the Bank is providing an account, product or access to the Services.
Article 5 (Types of Service) 
The Services provided by the Bank shall include various kinds of banking services on the Internet from time to time, including without limitation, account inquiry, Transfer Services, account opening and closing, loan applications, international payments, automatic payments. More details will be provided through the relevant Service. 
Article 6 (Apply or Cancel for the Services) 
①	The provision of the Services shall commence after the User submits an application for the Services (the “Application”) to the Bank in writing and the Bank approves the Application. 
②	The Service shall be terminated on the User’s written request to the Bank. However, for certain types Services, the User may also terminate the Service using a specific feature in the Services on its Electronic Device, provided that the User takes sole responsibility for such termination. 
③	The Bank can suspend or terminate the User’s access to the Services or any functionality within the Services without notice at any time and without responsibility for any loss the User may suffer, if it considers there are good reasons to do so (e.g. breach of any law).
Article 7 (Method of Verification)
①	The User will be granted access and may use the Services by providing any or all of Means of Access specified in Article 4, Subparagraph 7 of these Terms and Conditions through its Electronic Device as instructed by the Bank.
②	The User agrees the Bank is entitled, at its discretion, to act on all instructions which appear to come from the User using the Means of Access. The User authorises the Bank to act and acknowledges that the Bank will rely on such instructions whether or not the User has actually given authority for the instruction.
③	The Bank reserves the right but is not required to ask about or confirm any instructions with the User, take additional steps to verify instructions made using the Means of Access or require further proof of identity or additional information of the User at any time.
④	If the User uses Biometric Authentication to access the Services, the User will not be required to provide the User Password or the EASY-PIN to access the Services. However, the applicable transaction and usage restrictions will be notified through an Electronic Device that is easily accessible by the User.
Article 8 (Issuance and Registration of Means of Access)
①	The Bank will issue an initial Means of Access to the User after the identification of the User is confirmed with the details provided in the Application. 
②	The User may access the Service using the Means of Access. The User shall choose a User Password the first time it accesses the Services. 
③	For corporate customers, the Master shall receive a OTP from the Bank as the initial Means of Access to the Services. The Master shall choose a User Password the first time it accesses the Services. The Master may register Subs by providing Customer IDs and setting the access and permissions levels for each Sub. On registration, each Sub will be provided with a OTP as an initial Means of Access. Each Sub must choose a User Password the first time it accesses the Services.  
④	The Master will be responsible for all the acts and omissions of a Sub in respect of its use of the Services. The Bank will deem each Sub as the Master’s agent in respect of the Services. The Bank will not be responsible for any loss or damages arising from the Sub’s acts or omissions to the Master in connection with these Services.
Article 9 (Management of Means of Access)
①	The User shall not lend, entrust, assign or encumber to a third party the Means of Access. 
②	The User shall not disclose the Means of Access to a third party and shall take good care in safeguarding the Means of Access to prevent stealing, forgery or alteration of the same. 
③	The User must ensure that all User Passwords and EASY-PINs are appropriate passwords. An appropriate password does not include any letters/numbers which are easily accessible personal data, for example consecutive numbers, the User’s date of birth, telephone numbers or identification numbers, etc. If the User uses an unsuitable password, the Bank will not be liable for any loss transaction regarding to these Services. 
④	All User Passwords and EASY-PINs must be memorised and shall not be recorded in writing.
⑤	The User shall not store passwords on any Electronic Device.
⑥	The User must immediately notify the Bank if it knows or suspects any disclosure, loss or theft of any Means of Access.  
Article 10 (Withdrawal Account)
①	The User shall nominate the initial Withdrawal Account in its Application to the Bank to be used in the transfer of funds. The User may also nominate additional Withdrawal Accounts by any way specified by the Bank for a relevant Service. 
②	The User may only nominate Withdrawal Accounts which are in the User’s own name or are jointly held with the User.
Article 11 (Deposit Account)
The Bank shall process the transaction based on the information provided by the User. Any or all loss or damages the User incurs from the User providing invalid account information, or if the Transfer Service is not made, is delayed, returned, or rejected for any reason, is the sole responsibility of the User.
Article 12 (Transfer Limit and Daily Limit)
①	The User must clearly set the maximum amount for each transaction (“Transaction Limit”) and the maximum amount permitted to be withdrawn each day (“Daily Limit”) in its Application. 
②	The User may change the Transfer Limit or Daily Limit by notifying the Bank of the changed amount in writing. For certain Services, such notice may be provided through a feature in that Service if specified by the Bank. 
③	The Transfer Limit and Daily Limit for the Sub shall be less than or equal to the Master’s Transfer Limit and Daily Limit. 
④	Transfer Limits do not apply to some transactions, such as Automatic Transfers, loan interest payments and/or fees which are charged by the Bank. 
Article 13 (Criteria for Processing Instructions)
①	The Bank shall, at its discretion, act on an instruction when the relevant Means of Access or submitted OTP included in the User’s Transaction Request matches the details registered with the Bank.
②	The Bank may suspend or block a transaction or decline to act on instructions without notice to the User at any time if the Bank considers the circumstances require the Bank to do so in its absolute discretion. For example only, where acting on the User’s instructions results in a breach of law.
③	If the Bank determines that a transaction requires FAA, the Bank shall not process the transaction until FAA has been given.
④	If FAA for an instruction is not provided within the stipulated timeframe, it will be automatically cancelled.
⑤	It is the User’s responsibility to ensure that the available funds in the Withdrawal Account exceeds the sum of the Requested Transaction amount and the applicable service charges. If any transaction is not made for any reason, it is the User’s responsibility to arrange for a subsequent payment to be made.  
⑥	If there are insufficient funds in the Withdrawal Account to meet the transaction amount and service charges the Bank may reject the instruction or may put the Withdrawal Account into overdraft to meet the amount required.
⑦	The Bank may withdraw funds from the Withdrawal Account in accordance with the User’s Transaction Request, without a separate payment request or additional confirmation.
Article 14 (Revocation of Transaction Requests)
①	The User can make a request to revoke a transaction by notifying the Bank, including notification through a feature on the relevant Service if the Bank has provided one. The Bank will advise whether a transaction may be revoked. 
②	The User acknowledges and agrees that the Bank may take up to one Business Day on receipt of the notice to process such requests and the Bank will not be liable for any loss if an instruction (including a Transaction Request) cannot be stopped or has already been executed.
③	The User acknowledges that any payment made by mistake can only be recovered with the consent of the holder of the Deposit Account.
④	When the Withdrawal Account is closed, any Transaction Request for Reserved Transfers registered with such account shall also be terminated.
⑤	Neither death nor adjudication of quasi-incompetency or incompetency of the User, nor dissolution, bankruptcy or merger of the User (if applicable), affects, revokes or modifies Transaction Requests or affects the rights of the Bank.
Article 15 (Correction of Errors) 
If the User is aware of an Error in the Services, the User may request the Bank to correct the Error. If the Bank learns that there is an Error in the Services, it shall investigate this. The Bank may unilaterally effect appropriate corrections to the Error and shall notify the User of the actions taken. 
Article 16 (Reporting any changes, lost or damaged User’s information)
①	If the User wishes to make changes to any of the items reported to the Bank such as its User Password, EASY-PIN, Withdrawal Account, name, company name, address, telephone number, etc., the User shall notify the Bank of such changes in writing. Such notification may also be provided through a feature in the Services, as advised by the Bank. 
②	When the User knows or suspects of the theft, loss, forgery or unauthorised alteration of the Means of Access to the Withdrawal Account(s) or disclosure of other information which is required to be kept confidential, the User shall promptly notify the Bank of such fact.  
③	The Bank will suspend all Services on receipt of the notice under the foregoing paragraph 2. 
④	In the event that the notification made under the foregoing paragraph 2 is revoked, the Bank may in its sole discretion, accept the revocation. The Service User shall file a written application with the Bank to resume the provision of the Services.  
Article 17 (Restriction on Use of the Services)
①	The User agrees that it will not use the Services for any purpose other than carrying out lawful purposes.
②	In any of the following cases, the Bank may restrict on any or all of the Service with respect to the relevant User:
1.	the User inputs a wrong User Password three times in a row or, five times in a row for EASY-PIN; 
2.	the User fails Biometric Authentication five times in a row;
3.	the User input a wrong account PIN number four times in a row;
4.	the password generated from OTP is erroneously entered ten times in a row;
5.	the amount requested for Transfer Services in a Transfer Request exceeds the Transfer Limit applicable to the User;
6.	the balance of the Withdrawal Account is less than the sum of transaction amount and applicable fees or charges at the time of execution;
7.	during the times notified by the Bank in accordance with Article 22(2);
8.	the User requests suspension of the Service;
9.	the Deposit Accounts or Withdrawal Accounts are closed or suspended;
10.	the Bank determines that the provision of Services may not be appropriate for reasons of legal restraints placed on withdrawal; and
11.	the Service is not available due to system errors or circumstances outside the Bank’s control including machine failure, problems with its network or industrial action.
③	Where possible, the Bank shall notify the User of the restriction on the use of the Services in accordance with Article 22(2). The User acknowledges and agrees that there may be some circumstances (e.g. if the Services are unavailable due to a system error) where the Bank may not be able to provide advance notice to the User.
④	If for any reason the Services are malfunctioning or are unavailable for use, it is the User’s responsibility to use other means to effect its transactions and banking. To the extent permitted by law, the Bank will not be responsible for any loss arising from the Bank’s restriction of the Services or any functionality within the Services.
Article 18 (Service Hour)
①	Subject to Article 17 above, the User may use the Service during the service hours set by the Bank as posted on its website. 
②	The service hours may be subject to change depending on the circumstances of the Bank. If the Bank wishes to change the service hours, it shall post such changes in accordance with Article 22(2), except in the cases of inevitable circumstances, such as system recovery, urgent program repair works, external causes, etc. 
Article 19 (Service Fees and Charges) 
①	Transfer service fees or charges set out in Appendix 1 of these Terms and Conditions shall be charged. The Bank shall automatically withdraw from the Withdrawal Account on provision of the Service. The Bank may change the fees and charges for its Services in accordance with Article 22(2).
②	The User is responsible for all fees and charges charged by its internet service provider and or mobile operator when it accesses any Service.
Article 20 (Indemnity and Exemption of Liability) 
①	To the extent permitted by law, the Bank is not responsible for any loss, damages, or claims or otherwise arising directly or indirectly in relation to the Services, including (without limitation) if:
1.	it is related to a security breach arising from the Service User’s misuse of the Means of Access;
2.	it acts on instruction in accordance with the User’s account operating authority or power of attorney (if any);
3.	it acts on instructions that are unauthorised, forged, or fraudulently given where it could not reasonably have detected that from the instructions;
4.	the Bank does not act on instructions it considers to be unclear or contradictory; 
5.	the User does not comply with any relevant terms for giving instructions; and
6.	there is malfunction of any equipment or system or any telecommunications link failure;
7.	any cause or event reasonably beyond the Bank’s control; and
8.	any unforeseen circumstances, for example, when unforeseen circumstances occur, including power breakdown, fire, terror attack or unexpected incidents. 
②	The User is responsible for: 
1.	using, having or obtaining Electronic Devices compatible with the Services. Compliance with any conditions of use relating to, or charges associated with the use of the User’s Electronic Devices or services accessed through those Electronic Devices are the User’s responsibility; and
2.	remedying any trojans, key logging software, viruses, spyware or other forms of malicious software that it knows are on any Electronic Device before it uses that Electronic Device for the Services.
③	The User at all times fully and effectively indemnifies the Bank for and against any and all claims, damages, actions, costs, expenses and losses which are made against the Bank which arise from the Bank acting upon an instruction which is given by the User or appears to be given on the User’s behalf, unless the Bank’s losses result directly from its own fraud or negligence.
Article 21 (User Information)
①	The Bank’s Privacy Policy applies to the Services. By using the Services, the User agrees that the Bank can collect, use and disclose information (including personal information) about it in accordance with the Privacy Policy. The Privacy Policy is available from our website (Home > Privacy Policy)
②	There may be times the Bank collects, uses and discloses information that is not an individual’s personal information and the Bank’s Privacy Policy will not apply (“non-personal information”). This may include when the Bank collects information about its business customers. The User authorises the Bank to collect, use and disclose non-personal information to help it manage and improve its systems, the Services and for product/market research purposes. The Bank may also use non-personal information to help it manage financial and security risks, monitor its systems, defend or enforce its rights and meet its legal obligations.
③	The User agrees to provide the Bank with non-personal information and the Bank may collect (including from third parties), use and disclose non-personal information to help it comply with laws in New Zealand and overseas. The Bank may also use non-personal information to monitor the User’s accounts and any of the Bank’s services or products for the purpose of preventing the misuse or unauthorised use of the Services, detecting any fraud or crime or for anti-money laundering and counter financing of terrorism purposes in connection with any laws in New Zealand or overseas.
	Article 22 (Amendment to Terms and Conditions) 
①	Where permitted by law, the Bank may change or upgrade any Service, these Terms and Conditions and the fees and charges set out at Appendix 1 at any time. If the Bank amends the Terms and Conditions in a way which affects the User, it shall notify the User one (1) month prior to the effective date of such contemplated amendment in accordance with Article 22(2). However, where changes are made to protect the security of the Bank’s systems or to comply with a change in the law, the Bank may tell the User after the change has been effected.
②	The Bank may notify the User in any of the following ways:
1.	putting up a notice at the Bank’s physical branch office; 
2.	posting it on its website; 
3.	posting a notice that can be seen when accessing the Services on the Electronic Devices; and 
4.	give notice to the User via e-mail. 
③	If the User does not agree with the changes, it may cancel the Services pursuant to Article 6 of these Terms and Conditions at any time. If the User does not cancel the Services by the previous Business Day of the effective date of the amendment, the User shall be deemed to agree to such amendment(s).
Article 23 (Other general terms applicable) 
①	If the User uses the Services for the purpose of a business (or if the User holds itself out as doing so), the User agrees that the Consumer Guarantees Act 1993 does not apply to the Services or associated products.
②	If a New Zealand Court decides that any of the terms in these Terms and Conditions are unlawful, the Bank will remove those terms in question and the remaining terms will be enforceable.
③	The Bank reserves its right to exercise its rights. Even if the Bank does not immediately exercise a right it has under these Terms and Conditions, it can still exercise that right in the future.
④	New Zealand law applies to these conditions.

ADDENDUM (11.Mar.2013)

Article 1 (Effective Date) The General Terms and Conditions shall take effect on 11 March 2013.

ADDENDUM (28.Nov.2016)

Article 1 (Effective Date) The General Terms and Conditions shall take effect on 28 November 2016.


ADDENDUM (22.Nov.2021)

Article 1 (Effective Date) The General Terms and Conditions shall take effect on 22 November 2021.

 
Appendix 1
Service Charges 
<table class="table -type04 nomargin">
  <colgroup>
    <col width="26%" />
    <col width="26%" />
    <col />
    <col width="18%" />
    <col width="18%" />
  </colgroup>
  <thead>
    <tr>
      <th scope="col">Service</th>
      <th scope="col">Detail</th>
      <th scope="col">Per</th>
      <th scope="col">Currency</th>
      <th scope="col">Charges</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>To KB Accounts</td>
      <td>Transfer between KB accounts</td>
      <td>item</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td>To Other Banks </td>
      <td>Transfer to Other banks</td>
      <td>item</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td rowspan="2">Foreign Currency Transfer</td>
      <td>Transfer to KB</td>
      <td>item</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td>Transfer to Other Banks </td>
      <td>item</td>
      <td>NZD</td>
      <td>25.00 </td>
    </tr>
      <tr>
      <td rowspan="2">Automatic Payments</td>
      <td>Set up</td>
      <td>item</td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td>Payment</td>
      <td>payment </td>
      <td>NZD</td>
      <td>0.00 </td>
    </tr>
    <tr>
      <td>Overseas Remittance</td>
      <td>Outward</td>
      <td>item</td>
      <td>NZD</td>
      <td>25.00 </td>
    </tr>
    <tr>
      <td>OTP</td>
      <td>Issuance</td>
      <td>item</td>
      <td>NZD</td>
      <td>15.00 </td>
    </tr>
  </tbody>
</table>
※ subject to change from time to time
<br><br><br>
    </template> 
  </pre>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  name: "serviceJoinStep1Contentsogauc",
  computed:{
    ...mapFields(["lang"])
  },
  data() {
    return {
    };
  },
  mounted(){
  }
}
</script>